var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 134,
    viewBox: "0 0 135 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.167 21.8333H25.8334C19.8292 21.8333 14.9713 26.7458 14.9713 32.7499L14.9167 98.2499C14.9167 104.254 19.8292 109.167 25.8334 109.167H113.167C119.171 109.167 124.083 104.254 124.083 98.2499V32.7499C124.083 26.7458 119.171 21.8333 113.167 21.8333ZM113.167 43.6666L69.5001 70.9582L25.8334 43.6666V32.7499L69.5001 60.0416L113.167 32.7499V43.6666Z",
    fill: "#EBF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2213 35.7501V35.7499C11.2213 29.8822 15.9689 25.0833 21.8334 25.0833H109.167C115.033 25.0833 119.833 29.8838 119.833 35.7499V101.25C119.833 107.116 115.033 111.917 109.167 111.917H21.8334C15.9673 111.917 11.1667 107.116 11.1667 101.25L11.2213 35.7501ZM109.299 46.8786L109.417 46.8051V46.6666V35.7499V35.2989L109.034 35.5379L65.5001 62.7468L21.9659 35.5379L21.5834 35.2989V35.7499V46.6666V46.8051L21.7009 46.8786L65.3676 74.1702L65.5001 74.2531L65.6326 74.1702L109.299 46.8786Z",
    stroke: "#0057B2",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/envelop.5bb229c65ad960a1b6ec9e064f330d16.svg";